// Dente #3 (céticos 2026-07-06) — o `proof` do update_feature_status era
// AUTO-ATESTADO (só min-length): o agente podia escrever "npx vitest → verde"
// sem nunca ter rodado nada. Agora o run_command REGISTRA o que rodou na sessão
// e o `passing` exige que o proof case com um comando que RODOU e saiu OK.
// Ring buffer em memória por sessão (cap+TTL); sessionId ausente = fail-open
// (harnesses headless antigos), presente = cross-check obrigatório.

const ring = new Map(); // sessionId → [{ command, exitOk, at }]
const CAP = 30;
const TTL_MS = 45 * 60_000;

export function recordRanCommand(sessionId, command, exitOk, now) {
  if (!sessionId || typeof command !== 'string' || !command.trim()) return;
  const at = Number.isFinite(now) ? now : 0;
  const list = ring.get(sessionId) || [];
  list.push({ command: command.trim(), exitOk: !!exitOk, at });
  ring.set(sessionId, list.slice(-CAP));
}

/** Só para testes/higiene. */
export function clearRanCommands(sessionId) { ring.delete(sessionId); }

function normalize(s) {
  return String(s || '').toLowerCase().replace(/\s+/g, ' ').trim();
}
function tokens(s) {
  return new Set(normalize(s).split(' ').filter((t) => t.length > 1));
}
function overlapRatio(claimedSet, ranSet) {
  if (!claimedSet.size) return 0;
  let hit = 0;
  for (const t of claimedSet) { if (ranSet.has(t)) hit += 1; }
  return hit / claimedSet.size;
}

/**
 * O proof cita um comando que RODOU nesta sessão (fresco) e saiu OK?
 * Regra: o trecho-comando do proof (antes de →/->) precisa casar com um comando
 * registrado — inclusão ou ≥60% dos tokens.
 * @returns {{ok: boolean, why?: string}}
 */
export function proofMatchesRanCommand(sessionId, proof, now) {
  if (!sessionId) return { ok: true }; // fail-open sem sessão (headless legado)
  const ref = Number.isFinite(now) ? now : Number.MAX_SAFE_INTEGER; // sem relógio: não expira (pure-engine — Date.now é do caller)
  const claimedRaw = String(proof || '').split(/→|->/)[0];
  const claimed = normalize(claimedRaw);
  if (!claimed) return { ok: false, why: 'proof sem trecho de comando identificável (formato: "<comando> → <resultado>")' };
  const fresh = (ring.get(sessionId) || []).filter((c) => ref === Number.MAX_SAFE_INTEGER || ref - c.at <= TTL_MS);
  if (!fresh.length) return { ok: false, why: 'nenhum run_command rodou nesta sessão' };
  const claimedSet = tokens(claimed);
  const hit = fresh.find((c) => {
    const ran = normalize(c.command);
    return ran.includes(claimed) || claimed.includes(ran) || overlapRatio(claimedSet, tokens(ran)) >= 0.6;
  });
  if (!hit) return { ok: false, why: 'o comando citado no proof não corresponde a nenhum comando RODADO nesta sessão' };
  if (!hit.exitOk) return { ok: false, why: 'o comando citado RODOU mas saiu com ERRO/timeout — isso não prova passing' };
  return { ok: true };
}
